import { useEffect, useRef, RefObject } from 'react';

/**
 * Hook customizado para detectar cliques fora do elemento referenciado.
 * @param handler Função a ser chamada quando um clique fora for detectado.
 * @returns RefObject<HTMLElement | null> para ser anexado ao elemento container.
 */
const useClickOutside = <T extends HTMLElement>(handler: () => void): RefObject<T | null> => {
  const domNodeRef = useRef<T>(null);

  useEffect(() => {
    const maybeHandler = (event: MouseEvent) => {
      if (domNodeRef.current && !domNodeRef.current.contains(event.target as Node)) {
        handler();
      }
    };

    document.addEventListener('mousedown', maybeHandler);

    return () => {
      document.removeEventListener('mousedown', maybeHandler);
    };
  }, [handler]);

  return domNodeRef;
};

export default useClickOutside;